export default "__VITE_ASSET__C18RlMRF__"